import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'withdrawalStatusTransform',
  standalone: true,
})
export class WithdrawalStatusTransformPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'PENDING':
        return 'Pending';
      case 'FAILED':
        return 'Failed';
      case 'SUCCESS':
        return 'Success';
      default:
        return value;
    }
  }
}
